var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBack(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 11,
    viewBox: "0 0 30 11",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.87087 10.7812L0.21431 6.02812C-0.0714393 5.73645 -0.0714392 5.26355 0.21431 4.97187L4.87087 0.218757C5.15662 -0.0729172 5.61991 -0.0729172 5.90566 0.218757C6.19141 0.510433 6.19141 0.983332 5.90566 1.27501L2.4982 4.75312L29.2531 4.75312C29.6656 4.75312 30 5.08751 30 5.5C30 5.91249 29.6656 6.24688 29.2531 6.24688L2.4982 6.24688L5.90566 9.72499C6.19141 10.0167 6.19141 10.4896 5.90566 10.7812C5.61991 11.0729 5.15662 11.0729 4.87087 10.7812Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBack);
export default __webpack_public_path__ + "static/media/back.25a68247ec43efe86c83b429991f0780.svg";
export { ForwardRef as ReactComponent };